package xim.poc.game.configuration.v0.tactics

import xim.math.Vector3f
import xim.poc.Scene
import xim.poc.SceneManager
import xim.poc.browser.DatLoader
import xim.poc.browser.DatWrapper
import xim.poc.game.configuration.EventItem
import xim.poc.tools.ZoneConfig
import xim.resource.table.ZoneIdToResourceId.getMainAreaResourcePath

private val referencePoint = Vector3f(x=280.00f,y=8.00f,z=324.00f)
private val keepObjects = panelZoneObjectIdLayout.flatten().toSet()

private val pillarIds = listOf(1160, 1265, 1266, 1268, 1269, 1272, 1284, 1285, 1288, 1289, 1290, 1291)

class TacticsPillarToggle(val show: Boolean): EventItem {

    override fun start() {
        toggleObjects(SceneManager.getCurrentScene())
    }

    override fun isComplete(): Boolean {
        return true
    }

    private fun toggleObjects(scene: Scene) {
        val newScale = if (show) { Vector3f.ONE } else { Vector3f.ZERO }
        val zoneObjs = scene.getMainArea().getZoneResource().zoneObj
        pillarIds.forEach { zoneObjs[it].scale.copyFrom(newScale) }
    }

}

class TacticsLoadSubAreaEvent(val scene: Scene, val subArea: TacticsChallengeFlavorArea): EventItem {

    private lateinit var datWrapper: DatWrapper

    companion object {
        fun preload(subArea: TacticsChallengeFlavorArea) {
            val resource = getMainAreaResourcePath(zoneConfig = ZoneConfig(zoneId = subArea.zoneId)) ?: return
            DatLoader.load(resource)
        }
    }

    override fun start() {
        hideZoneObjects(scene)
        datWrapper = scene.loadSecondaryArea(ZoneConfig(zoneId = subArea.zoneId)).onReady {
            scene.transformSecondaryArea(position = subArea.position - referencePoint, subArea.yRotate)
        }
    }

    override fun isComplete(): Boolean {
        return datWrapper.isReady()
    }

    private fun hideZoneObjects(scene: Scene) {
        scene.getMainArea().getZoneResource().zoneObj.filter { !keepObjects.contains(it.index) }
            .onEach { it.position.y += 1_000f }
    }

}

class TacticsUnloadSubAreaEvent(val scene: Scene): EventItem {

    override fun start() {
        scene.getSecondaryArea() ?: return
        scene.unloadSecondaryArea()
        showZoneObjects(scene)
    }

    override fun isComplete(): Boolean {
        return true
    }

    private fun showZoneObjects(scene: Scene) {
        scene.getMainArea().getZoneResource().zoneObj.filter { !keepObjects.contains(it.index) }
            .onEach { it.position.y -= 1_000f }
    }

}